export * from './chapter';
export * from './chat';
export * from './chat-links';
export * from './deviceInformation';
export * from './environment';
export * from './layout';
export * from './logging';
export * from './menu';
export * from './participant';
export * from './player-stats';
export * from './poll-with-votes';
export * from './speaker';
export * from './survey';
export * from './test-webinar';

export * from './broadcast-quality';

export enum RecorderStatus {
    Idle,
    Initializing,
    StandBy,
    Recording,
    Error
}

export enum WebinarStatus {
    Planned = 0,
    Started = 1,
    Ended = 2,
    Cancelled = 3,
    Expired = 4
}

export enum WebinarVisibility {
    Private = 0,
    Public = 1
}

export enum OnDemandStatus {
    None = 0,
    Processing = 1,
    Available = 2,
    Failed = 3
}

export enum LiveStatus {
    Offline,
    Live,
    Paused,
    Error = 500
}

export enum StreamValidation {
    Unknown = 0,
    Ok = 1,
    BlockedAudioChannels = 2,
    BlockedVideoLevel = 3,
    BlockedAudioChannelsAndVideoLevel = 4
}

/**
 * How the presenter's video reaches Vindral. Values must match
 * Grains.Interfaces/Webinar/Models/IngestType.cs exactly - the wire carries integers.
 */
export enum IngestType {
    Unknown = 0,
    WebRtc = 1,
    Moq = 2,
    Rtmp = 3,
    Srt = 4
}

export enum VideoLayout {
    Default = 0,
    VideoOnly = 0,
    PresentationWithVideoLarge = 1,
    PresentationWithVideoSmall = 2,
    DesktopSharing = 3,
    DesktopSharingWithVideo = 4,
    Classic = 5
}

export enum DisconnectReason {
    DuplicateSession,
    Error,
    Kicked,
    TestWebinarFull // appended last; wire value 3 — must match Dashboard/Models/DisconnectReason.cs
}

export interface SubtitlesTrack {
    trackId: string;
    isEnabled: boolean;
    isDefault: boolean;
    subtitles: Subtitle[];
}

export interface Subtitle {
    start: string;
    end: string;
    lines: string[];
}

export interface SubtitlesGeneratorStatus {
    isGenerating: boolean;
}

export interface SubtitlesGeneratorOptions {
    deepgram: DeepgramGenerateSubtitlesOptions;
}

export interface DeepgramGenerateSubtitlesOptions {
    isEnabled: boolean;
    trackId: string;
    model: string;
    language: string;
}
